export default __webpack_public_path__ + "static/media/PayPal_logo.794b19f8.png";